import React from "react";
import Skeleton from "react-loading-skeleton";

export function SkeletonGridCard() {
  return (
    <div
      style={{
        border: "1px solid #eee",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        padding: "24px",
        background: "#fff",

        margin: "auto",
        marginBottom: 24,
        marginRight: 4,
      }}
    >
      <div style={{ marginBottom: 8 }}>
        <Skeleton height={24} width={120} />
      </div>
      <div style={{ marginBottom: 8 }}>
        <Skeleton height={16} width={120} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <Skeleton height={16} width={100} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={80} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={80} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={100} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={90} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={60} />
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
        <Skeleton height={16} width={120} />
      </div>
    </div>
  );
}

export function SkeletonListCard() {
  return (
    <div
      style={{
        display: "flex",
        border: "1px solid #eee",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        background: "#fff",
        minHeight: 150,
        margin: "8px 0",
        padding: 16,
        gap: 24,
      }}
    >
      {/* Left column */}
      <div style={{ flex: 1, minWidth: 320 }}>
        <div style={{ marginBottom: 8 }}>
          <Skeleton height={28} width={220} />
        </div>
        <div style={{ marginBottom: 8 }}>
          <Skeleton height={18} width={260} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <Skeleton height={16} width={120} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={120} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={120} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={20} width={20} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={140} />
        </div>
      </div>
      {/* Divider */}
      <div
        style={{
          width: 1,
          background: "#eee",
          margin: "0 24px",
          minHeight: 180,
          alignSelf: "center",
        }}
      />
      {/* Right column */}
      <div style={{ flex: 1, minWidth: 320 }}>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 12 }}
        >
          <Skeleton circle height={22} width={22} style={{ marginRight: 8 }} />
          <Skeleton height={22} width={140} />
        </div>
        <div style={{ marginBottom: 8 }}>
          <Skeleton height={16} width={180} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={18} width={18} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={180} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={18} width={18} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={120} />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <Skeleton circle height={18} width={18} style={{ marginRight: 8 }} />
          <Skeleton height={16} width={120} />
        </div>
        <div style={{ marginTop: 24 }}>
          <Skeleton height={18} width={120} />
        </div>
      </div>
    </div>
  );
}
